"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIconNameValid = exports.getIconNames = exports.isStandardMaterialIconNameValid = exports.isStandardExpediaIconNameValid = exports.isStandardIconNameValid = void 0;
var iconManifest = __importStar(require("@ferris/core/icons/icon-manifest-standard.json"));
var isStandardIconNameValid = function (iconName) {
    return exports.isStandardExpediaIconNameValid(iconName) || exports.isStandardMaterialIconNameValid(iconName);
};
exports.isStandardIconNameValid = isStandardIconNameValid;
var isStandardExpediaIconNameValid = function (iconName) {
    return iconManifest.expedia.indexOf(iconName) !== -1;
};
exports.isStandardExpediaIconNameValid = isStandardExpediaIconNameValid;
var isStandardMaterialIconNameValid = function (iconName) {
    return iconManifest.material.indexOf(iconName) !== -1;
};
exports.isStandardMaterialIconNameValid = isStandardMaterialIconNameValid;
var getIconNames = function () {
    return [].concat(iconManifest.expedia, iconManifest.material).sort();
};
exports.getIconNames = getIconNames;
exports.isIconNameValid = exports.isStandardIconNameValid;
